@if (form) {
  <form
    (submitted)="submitForm($event)"
    [appFormDisabled]="formSubmitted"
    [formGroup]="form"
    appFormSubmit
    class="direct-debit-form"
  >
    <app-grid-row>
      <app-grid-column [md]="6">
        <div class="direct-debit__title-container">
          <h1 class="direct-debit__title">
            {{ "CHECKOUT_PAGE_TITLE" | translate }}
          </h1>
          <div class="direct-debit__img-container">
            <div class="direct-debit__secure-image">
              <img
                [src]="`assets/lock.svg`"
                alt="lock"
                class="direct-debit__lock-img"
              />
              <img
                [src]="`assets/secure.svg`"
                alt="secure"
                class="direct-debit__secure-img"
              />
            </div>
            <img
              [src]="`assets/direct-debit.svg`"
              alt="direct debit"
              class="direct-debit__direct-debit-img"
            />
          </div>
        </div>

        @if (hasPromo()) {
          <app-single-plan-promo-price
            [titlePriceVariant]="TitlePriceVariant.BodyLarger"
            [verboseSuffix]="true"
          />
        } @else {
          <h2 class="direct-debit__monthly-payment">
            <strong>{{
              "CHECKOUT_PAGE_MONTHLY_PAYMENT_LABEL_AND_PRICE"
                | translate
                  : {
                      price: total() | currencyFormat,
                    }
            }}</strong>
            {{ "CHECKOUT_PAGE_MONTHLY_PAYMENT_PER_MONTH" | translate }}
          </h2>
        }

        <hr class="direct-debit__heading-divider" />

        <h3 class="direct-debit__subtitle">Required information*</h3>

        <app-form-field
          [appFormField]="formFields.accountHolder"
          class="direct-debit-form__field"
          formControlName="accountName"
        >
          <app-form-text-input [appQmSanitise]="'block'" />
        </app-form-field>

        <app-form-field
          [appFormField]="formFields.accountNumber"
          class="direct-debit-form__field"
          formControlName="accountNumber"
        >
          <app-form-text-input [appQmSanitise]="'block'" />
        </app-form-field>

        <app-form-field
          [appFormField]="formFields.sortcode"
          class="direct-debit-form__field"
          formControlName="sortCode"
        >
          <app-form-sortcode-single-input [appQmSanitise]="'block'" />
        </app-form-field>

        <app-form-field
          [appFormField]="formFields.paymentDate"
          class="direct-debit-form__field"
          formControlName="paymentDate"
        >
          <app-form-select
            [appQmSanitise]="'block'"
            [fill]="true"
            [options]="formFields.paymentDateOptions"
          />
        </app-form-field>

        <h3 class="direct-debit-form__account-holder-heading">
          Confirm payment authorisation*
        </h3>
        <app-form-field
          [appFormField]="formFields.accountHolderConfirmation"
          class="direct-debit-form__field"
          formControlName="accountHolderConfirmation"
        >
          <app-form-checkbox [size]="'medium'" />
        </app-form-field>
      </app-grid-column>
      <app-grid-column [block]="'md'" [hidden]="'xs'" [md]="6">
        <app-basket
          [startCollapsed]="false"
          appSticky
          class="direct-debit__basket"
        />
      </app-grid-column>
    </app-grid-row>
    <hr class="direct-debit__form-divider" />
    <h2 class="direct-debit__important-title">The important bits</h2>
    <section class="direct-debit-form-legal">
      <app-accordion class="direct-debit-guarantee-accordion">
        <app-accordion-panel
          [accordionPanelContentTemplate]="accordionPanelContentTemplate"
          [accordionPanelHeaderTemplate]="accordionPanelHeaderTemplate"
        />
        <ng-template #accordionPanelHeaderTemplate let-expanded="expanded">
          <span
            [class.direct-debit-guarantee-accordion__header--expanded]="
              expanded
            "
            class="direct-debit-guarantee-accordion__header"
          >
            <span class="direct-debit-guarantee-accordion__header-title">
              {{
                "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_GUARANTEE_TITLE" | translate
              }}
            </span>

            <app-icon
              [name]="'chevron-down'"
              [size]="'md'"
              class="direct-debit-guarantee-accordion__header-icon"
            />
          </span>
        </ng-template>

        <ng-template #accordionPanelContentTemplate let-expanded="expanded">
          <ul class="direct-debit-guarantee-accordion__body-list">
            <li class="direct-debit-guarantee-accordion__body-list-item">
              This guarantee is offered by all banks and building societies that
              accept instructions to pay Direct Debits.
            </li>
            <li class="direct-debit-guarantee-accordion__body-list-item">
              If there are any changes to the amount or frequency of your Direct
              Debit, <strong>Domestic & General Insurance PLC</strong> will
              notify you 14 working days in advance of your account being
              debited or otherwise agreed. If you request
              <strong>Domestic & General Insurance PLC</strong> to collect a
              payment, confirmation of the amount and date will be given to you
              at the time of the request.
            </li>
            <li class="direct-debit-guarantee-accordion__body-list-item">
              If an error is made in the payment of your Direct Debit, by
              <strong>Domestic & General Insurance PLC</strong> or your bank or
              building society, you are entitled to a full and immediate refund
              of the amount paid from your bank or building society. If you
              receive a refund you are not entitled to, you must pay it back
              when <strong>Domestic & General Insurance PLC</strong>
              asks you to.
            </li>
            <li class="direct-debit-guarantee-accordion__body-list-item">
              You can cancel a Direct Debit at any time by simply contacting
              your bank or building society. Written confirmation may be
              required. Please also notify us.
            </li>
          </ul>
        </ng-template>
      </app-accordion>

      <p class="direct-debit-form-legal__disclaimer">
        Your Direct Debit instruction will be confirmed to you by email within
        14 working days prior to the first collection — as long as that takes
        place within the first month. Your protection is provided by Domestic &
        General Insurance PLC, which will show on your bank statements as D&G.
      </p>

      <div class="direct-debit-form-legal-cover-start">
        <h5 class="direct-debit-form-legal-cover-start__title">
          {{ "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_TITLE" | translate }}
        </h5>

        @if (isMultiPlanJourney) {
          <p class="direct-debit-form-legal-cover-start__description">
            {{
              "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE_MULTI_PLAN"
                | translate
            }}
          </p>
        } @else {
          @if (inWarranty) {
            <p class="direct-debit-form-legal-cover-start__description">
              {{
                "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE"
                  | translate
              }}
            </p>
          } @else {
            <p class="direct-debit-form-legal-cover-start__description">
              {{
                "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_START_DESCRIPTION_ONE_OOG"
                  | translate
              }}
            </p>
          }
        }
      </div>

      <h6 class="direct-debit-form-legal-terms-conditions-title">
        {{
          "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_TITLE"
            | translate
        }}
      </h6>

      <div class="direct-debit-form-legal-terms-conditions">
        <p class="direct-debit-form-legal-terms-conditions__description">
          {{
            "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_ONE"
              | translate
          }}
          <app-link
            [navigationLink]="{
              label:
                'CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_LINK_TCS_TEXT'
                | translate,
              href: termsUrl(),
            }"
            [newWindow]="true"
            class="link--regular"
          />.
        </p>
        <p class="direct-debit-form-legal-terms-conditions__description">
          {{
            "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_TWO_PREFIX"
              | translate
          }}
          <app-link
            [navigationLink]="{
              label:
                'CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_LINK_IPID_TEXT'
                | translate,
              href: ipidUrl(),
            }"
            [newWindow]="true"
            class="link--regular"
          />
          {{
            "CHECKOUT_DIRECT_DEBIT_FORM_LEGAL_COVER_TERMS_AND_CONDITIONS_DESCRIPTION_TWO_SUFFIX"
              | translate
          }}
        </p>
      </div>
    </section>

    <app-form-field
      [appFormField]="formFields.termsAndConditions"
      class="direct-debit-form__field"
      formControlName="termsAndConditions"
    >
      <app-form-checkbox [size]="'medium'" />
    </app-form-field>

    <hr class="direct-debit__paperless-divider" />

    <p class="direct-debit-form-paperless-label">
      {{ "CHECKOUT_DIRECT_DEBIT_FORM_PAPERLESS_LABEL" | translate }}
    </p>

    <p class="direct-debit-form-paperless-description">
      {{ "CHECKOUT_DIRECT_DEBIT_FORM_PAPERLESS_DESCRIPTION" | translate }}
    </p>

    <app-form-field
      [appFormField]="formFields.paperless"
      class="direct-debit-form__field"
      formControlName="paperlessPreference"
    >
      <app-form-checkbox [size]="'medium'" />
    </app-form-field>

    @if (validationAttempted && !checkoutService.validAccountNumberSortCode()) {
      <div class="direct-debit-form__validation-error">
        {{
          "CHECKOUT_DIRECT_DEBIT_FORM_PAYMENT_DETAILS_VALIDATION_ERROR"
            | translate
        }}
      </div>
    }

    <div class="direct-debit-form__submit-container">
      <app-form-submit-button
        [fill]="true"
        [loading]="formSubmitted"
        class="direct-debit-form__submit"
      >
        {{
          "CHECKOUT_DIRECT_DEBIT_FORM_CTA" | translate
        }}</app-form-submit-button
      >
    </div>
  </form>
}
